module.exports = __webpack_public_path__ + "static/media/SecPumpImg.bf080422.png";